$(document).ready(function(){
  $(document).on('click',".t4s-btn-coupon",function(){
    let text = $(this).data("coupon");
    navigator.clipboard.writeText(text);
    $(this).find(".tooltiptext").text( T4Sstrings.copied_tooltipText + ": " + text);

  })
  $(document).on('mouseleave',".t4s-btn-coupon",function(){
    $(this).find(".tooltiptext").text(T4Sstrings.copy_tooltipText);
   
  })
});

// Mobile menu drawer: clicking on each category opens sub-values instead of navigating to collection link
(function() {
  if (window._t4sMbNavClickInit) return;
  window._t4sMbNavClickInit = true;

  document.addEventListener('click', function(e) {
    var targetEl = e.target && e.target.nodeType === 3 ? e.target.parentElement : e.target;
    if (!targetEl || typeof targetEl.closest !== 'function') return;

    var anchor = targetEl.closest('#t4s-menu-drawer .t4s-menu-item-has-children > a');
    if (!anchor) return;

    // Prevent opening category collection link & prevent theme double-trigger
    e.preventDefault();
    e.stopPropagation();

    var li = anchor.closest('.t4s-menu-item-has-children');
    if (!li) return;

    var $ = window.jQuery_T4NT || window.jQuery || window.$;
    if ($) {
      var $li = $(li);
      if ($li.hasClass('is--opend')) {
        $li.removeClass('is--opend').children('ul').slideUp(200);
      } else {
        $li.siblings('.t4s-menu-item-has-children.is--opend').removeClass('is--opend').children('ul').slideUp(200);
        $li.addClass('is--opend').children('ul').slideDown(200);
      }
    } else {
      var ul = li.querySelector(':scope > ul');
      var wasOpen = li.classList.contains('is--opend');
      var siblings = li.parentElement ? li.parentElement.querySelectorAll(':scope > .t4s-menu-item-has-children.is--opend') : [];
      for (var s = 0; s < siblings.length; s++) {
        siblings[s].classList.remove('is--opend');
        var sub = siblings[s].querySelector(':scope > ul');
        if (sub) sub.style.display = 'none';
      }
      if (wasOpen) {
        li.classList.remove('is--opend');
        if (ul) ul.style.display = 'none';
      } else {
        li.classList.add('is--opend');
        if (ul) ul.style.display = 'block';
      }
    }
  }, true);
})();